import { render } from "./editor.vue?vue&type=template&id=5c5dcfb1&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=5c5dcfb1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5dcfb1"],['__file',"src/pages/scada/components/editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c5dcfb1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c5dcfb1', __exports__)) {
    console.log('reload')
    api.reload('5c5dcfb1', __exports__)
  }
  
  module.hot.accept("./editor.vue?vue&type=template&id=5c5dcfb1&scoped=true", () => {
    console.log('re-render')
    api.rerender('5c5dcfb1', render)
  })

}


export default __exports__